module.exports = __webpack_public_path__ + "img/89.8.TSS.fd65ccc7.png";